import { render, staticRenderFns } from "./EditOrderTemplatePixelStatus.vue?vue&type=template&id=84f08110&"
import script from "./EditOrderTemplatePixelStatus.vue?vue&type=script&lang=js&"
export * from "./EditOrderTemplatePixelStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports